import {IAdditionalData} from "../../models/Extension";
import React, {useEffect} from "react";
import {ComboBox} from "@fluentui/react";
import {useGetExtensionInstallOptionsQuery} from "../../store/Api";

interface IExtensionInstallOptionProps {
    initialValue: string;
    optionsField: IAdditionalData;
    extensionId: string;
    onChange: (field: string, value: string) => void;
    readOnly?: boolean;
    // Mount-time auto-selection (re-announcing the initial value, or picking the declared default) is not
    // a user edit. Callers that must not treat it as one — e.g. forms that save on change — receive it
    // here instead; without this, it falls through to onChange, preserving the original behavior.
    onAutoSelect?: (field: string, value: string) => void;
}
const ExtensionInstallOption: React.FC<IExtensionInstallOptionProps> = (props) => {
    
    const [extensionId, setExtensionId] = React.useState<string | undefined>(undefined);

    useEffect(() => {
        setExtensionId(props.extensionId)
    }, [props.extensionId]);
    const fieldOptions = useGetExtensionInstallOptionsQuery({extensionId: props.extensionId, field: props.optionsField.field}, {skip:(!props.extensionId || !props.optionsField.field)})
    const [selectedOption, setSelectedOption] = React.useState<string>()
    
    useEffect(() => {
        if(!selectedOption && fieldOptions?.data){
            const announce = props.onAutoSelect ?? props.onChange;
            const previousDefault = props.initialValue;
            if(previousDefault){
                setSelectedOption(previousDefault)
                announce(props.optionsField.field, previousDefault)
            }
            else {
                const defaultOption = fieldOptions?.data?.options?.filter((a) => a.default)
                if (defaultOption && defaultOption.length > 0) {
                    setSelectedOption(defaultOption[0].value)
                    announce(props.optionsField.field, defaultOption[0].value)
                }
            }
        }
        }, [fieldOptions.data]
    )

    // The saved value no longer exists among the options the extension just offered — the remote entity
    // was deleted or renamed. Left alone this breaks the extension quietly at run time, so it is called
    // out here, where the user can pick a replacement. Only judged against a successful answer.
    const savedValueUnavailable =
        fieldOptions.isSuccess && fieldOptions.data?.success === true && !fieldOptions.isFetching &&
        !!selectedOption && !(fieldOptions.data?.options ?? []).some(o => o.value === selectedOption);

    const getError = () => {
        if (savedValueUnavailable)
            return `The saved value "${selectedOption}" is no longer available from the connected system. Select a replacement.`;
        return !props.optionsField.optional && !selectedOption ? "Field is required" : "";
    }

    return(<ComboBox
        label={props.optionsField.description}
        options={fieldOptions.data?.options?.map(c => ({
            key: c.value,
            text: c.display
        })) ?? []}
        autoComplete={"on"}
        errorMessage={getError()}
        disabled={fieldOptions.isFetching || props.readOnly}
        required={!props.optionsField.optional}
        placeholder={"Select Option"}
        selectedKey={selectedOption}
        onChange={(e, d) => {
            setSelectedOption(d?.key?.toString() ?? "")
            props.onChange(props.optionsField.field, d?.key.toString() ?? '')
        }}/>);
}
export default ExtensionInstallOption;